import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SubstitutionsApi } from "../../../api/substitutions";
import { QueryKey } from "../../../consts/query-keys";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { useFetchError } from "../../../hooks/useFetchError";
import { ApiError } from "../../../types/api-error";

export const useDeleteSubstitution = (datasetId?: number) => {
  const queryClient = useQueryClient();

  const { handleSuccess } = useApiSuccess({
    snackbarText: "Substitution deleted.",
  });

  const mutationFn = (id: number) =>
    SubstitutionsApi.delete({
      path: {
        datasetId: datasetId!,
        substitutionId: id,
      },
    });

  const { mutate, error, isPending } = useMutation<unknown, ApiError, number>({
    mutationKey: [QueryKey.Substitutions, "delete", datasetId],
    mutationFn,
    onSuccess: () => {
      handleSuccess();
      queryClient.invalidateQueries({
        queryKey: [QueryKey.Substitutions, datasetId],
      });
    },
  });

  useFetchError(error);

  return { deleteSubstitution: mutate, isPending };
};
